import { c as _c } from "react/compiler-runtime";
import { Placement } from "@floating-ui/react-dom";
import clsx from "clsx";
import { FC, PropsWithChildren } from "react";
import Icon from "../Icon";
import Popover from "../Popover";
const sizes: Record<InfoIconSize, number> = {
  xs: 12,
  sm: 14,
  md: 18,
  lg: 28
};
export type InfoIconSize = "xs" | "sm" | "md" | "lg";
export type InfoIconVariant = "primary" | "neutral";
export interface InfoIconProps extends PropsWithChildren {
  inverted?: boolean;
  placement?: Placement;
  size?: InfoIconSize;
  variant?: InfoIconVariant;
  label?: string;
}
const InfoIcon: FC<InfoIconProps> = t0 => {
  const $ = _c(16);
  const {
    placement,
    children,
    inverted,
    size: t1,
    variant: t2,
    label
  } = t0;
  const size = t1 === undefined ? "md" : t1;
  const variant = t2 === undefined ? "primary" : t2;
  const iconSize = sizes[size];
  const t3 = !inverted && variant === "primary";
  const t4 = !inverted && variant === "neutral";
  let t5;
  if ($[0] !== inverted || $[1] !== t3 || $[2] !== t4) {
    t5 = clsx("cursor-pointer -m-2xs -ml-2xs p-2xs flex focus-visible:ring-2 focus-visible:ring-primary-800 focus:outline-none rounded-s relative", {
      "text-neutral-0": inverted,
      "text-primary-800 hover:text-primary-825": t3,
      "text-neutral-150 hover:text-primary-800": t4
    });
    $[0] = inverted;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== label) {
    t6 = label && <span className="sr-only">{label}</span>;
    $[4] = label;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== iconSize) {
    t7 = <Icon size={iconSize} type="Info" />;
    $[6] = iconSize;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t5 || $[9] !== t6 || $[10] !== t7) {
    t8 = <span className={t5}>{t6}{t7}</span>;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== children || $[13] !== placement || $[14] !== t8) {
    t9 = <Popover placement={placement} content={children} trigger="hover" variant="white">{t8}</Popover>;
    $[12] = children;
    $[13] = placement;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
};
export default InfoIcon;